import { createReducer } from 'AppSrc/core/reducers/create-reducer';
import {
  SET_CRQ_SPONSOR_REQUEST,
  SET_CRQ_SPONSOR_SUCCESS,
  SET_CRQ_SPONSOR_ERROR,
} from './sponsor-actions';

const defaultState = {
  savingSponsor: false,
};

// generate an action handler that sets savingSponsor value
// function accepts the value desired for savingSponsor
const setSavingSponsor = (savingSponsor) => (state, action) => ({
  ...state,
  savingSponsor,
});

const actionHandlers = {
  [SET_CRQ_SPONSOR_REQUEST]: setSavingSponsor(true),
  [SET_CRQ_SPONSOR_SUCCESS]: setSavingSponsor(false),
  [SET_CRQ_SPONSOR_ERROR]: setSavingSponsor(false),
};

const sponsorReducer = createReducer(defaultState, actionHandlers);

export {
  sponsorReducer,
  defaultState,
};
